import Backbone from 'backbone'
import _ from 'lodash'
import $ from 'jquery'
import permissions from 'scoreboard/components/permissions'

var Bookmark = Backbone.Model.extend({

	section: 'bookmarks',
	domainType: 'bookmark',

	urlRoot: 'api/bookmarks',

	/**
	 * Returns the URL for the bookmark, including any persisted UI state that
	 * should be restored.
	 */
	getStatefulUrl: function () {
		let url = this.get('url')

		if (!_.isEmpty(this.get('uiState'))) {
			url += '?' + $.param({ state: this.get('uiState') })
		}

		return url
	},

	isEditable: function() {
		return permissions.bookmarks()
	}

})

export default Bookmark

Bookmark.__filename__ = 'bookmarks/bookmark.js'
